import { lazy, Suspense } from "react";

// Lazy load components
const Slider = lazy(() => import("../components/Slider"));
const FeatureSection = lazy(() =>
  import("../components/common/FeatureSection")
);
const FeaturedProducts = lazy(() =>
  import("../components/common/FeaturedProducts")
);
const TopSellerCarousel = lazy(() =>
  import("../components/common/TopSellerCarousel")
);
const BestSellerSection = lazy(() =>
  import("../components/common/BestSellerCarousel")
);
const LatestNews = lazy(() =>
  import("../components/common/blog/LatestNews")
);

const SectionLoader = () => (
  <div className="flex items-center justify-center py-12">
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-500"></div>
  </div>
);

export default function Home() {
  return (
    <>
      <Suspense fallback={<SectionLoader />}>
        <Slider />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <FeatureSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <FeaturedProducts />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <TopSellerCarousel />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <BestSellerSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <LatestNews />
      </Suspense>
    </>
  );
}